import {IFileDetailsStoreState} from './IFileDetailsStoreState';
import {fileDetailsInitialState} from './fileDetails.initialState';

export const fileDetailsReducer = {
  clear(state: IFileDetailsStoreState) {
    state.fileDetails = {...fileDetailsInitialState.fileDetails};
  },
};
